import { ArrowUturnLeftIcon } from "@heroicons/react/24/outline";
import { ColumnDef } from "@tanstack/react-table";
import { Button } from "@/core/components/ui/button";
import { Checkbox } from "@/core/components/ui/checkbox";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";
interface WithIdAndDismissedAt {
  id: string;
  dismissed_at: string | null;
}

const SelectionWithUndismissCol = <T extends WithIdAndDismissedAt>(
  onUndismissSpiff: (spiffId: string) => void,
  isLocked = false,
): ColumnDef<T> => ({
  id: "select",
  header: ({ table }) => {
    // Don't show header checkbox when locked
    if (isLocked) {
      return null;
    }

    const rows = table.getRowModel().rows;
    const selectableRows = rows.filter((row) => !row.original.dismissed_at);
    const selectedSelectableRows = selectableRows.filter((row) =>
      row.getIsSelected(),
    );
    const allSelectableSelected =
      selectableRows.length > 0 &&
      selectedSelectableRows.length === selectableRows.length;
    const someSelectableSelected =
      selectedSelectableRows.length > 0 &&
      selectedSelectableRows.length < selectableRows.length;

    return (
      <div className="flex h-full w-full items-center justify-center">
        <Checkbox
          checked={
            allSelectableSelected || (someSelectableSelected && "indeterminate")
          }
          onCheckedChange={(value) => {
            selectableRows.forEach((row) => {
              row.toggleSelected(!!value);
            });
          }}
          aria-label="Select all"
        />
      </div>
    );
  },
  cell: ({ row }) => {
    const isDismissed = !!row.original.dismissed_at;

    if (isDismissed) {
      // Always show reinstate button for dismissed spiffs, regardless of lock status
      return (
        <div className="flex h-full w-full items-center justify-center pl-1">
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  onUndismissSpiff(row.original.id);
                }}
                className="h-6 w-6 p-4"
              >
                <ArrowUturnLeftIcon className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>Reinstate this spiff</TooltipContent>
          </Tooltip>
        </div>
      );
    }

    // Don't show checkbox for non-dismissed spiffs when locked
    if (isLocked) {
      return null;
    }

    return (
      <div className="flex h-full w-full items-center justify-center pl-6">
        <Checkbox
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          aria-label="Select row"
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    );
  },
  meta: {
    size: "48px",
  },
  size: 48,
  maxSize: 48,
  minSize: 48,
  enableSorting: false,
});

export default SelectionWithUndismissCol;
